module.exports = __webpack_public_path__ + "img/builder-28.8a6997f5.webp";